import { render, staticRenderFns } from "./bbsDialog.vue?vue&type=template&id=72459185&scoped=true"
import script from "./bbsDialog.vue?vue&type=script&lang=js"
export * from "./bbsDialog.vue?vue&type=script&lang=js"
import style0 from "./bbsDialog.vue?vue&type=style&index=0&id=72459185&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72459185",
  null
  
)

export default component.exports